export default "__VITE_ASSET__bxvf9j_W__"